import type { DataSource, ProviderId } from './source.ts';

/**
 * Catalogue des fournisseurs affichables (attribution, licence).
 * Seuls les fournisseurs retenus pour la V0.1 ou déjà utilisés y figurent.
 * Références et points TO VERIFY : docs/02-data-sources.md.
 */
export const DATA_SOURCES = {
  fixture: {
    id: 'fixture',
    name: 'Données de démonstration',
    homepage: '/a-propos',
    license: { name: 'Données fictives' },
    attribution: 'Données fictives de développement : elles ne reflètent pas la réalité',
  },
  idfm: {
    id: 'idfm',
    name: 'Île-de-France Mobilités',
    homepage: 'https://prim.iledefrance-mobilites.fr',
    license: { name: 'Licence Mobilités', url: 'https://prim.iledefrance-mobilites.fr/fr/licences' },
    attribution: 'Île-de-France Mobilités',
  },
  'open-meteo': {
    id: 'open-meteo',
    name: 'Open-Meteo.com (modèles Météo-France)',
    homepage: 'https://open-meteo.com/',
    // Attribution exigée : lien vers Open-Meteo + lien vers la licence (https://open-meteo.com/en/licence).
    license: { name: 'CC BY 4.0', url: 'https://creativecommons.org/licenses/by/4.0/' },
    attribution: 'Données météo : Open-Meteo.com (prévisions issues des modèles Météo-France)',
  },
  'meteo-france': {
    id: 'meteo-france',
    name: 'Météo-France',
    homepage: 'https://vigilance.meteofrance.fr',
    license: { name: 'Licence Ouverte 2.0', url: 'https://www.etalab.gouv.fr/licence-ouverte-open-licence/' },
    attribution: 'Météo-France',
  },
  celestrak: {
    id: 'celestrak',
    name: 'CelesTrak',
    homepage: 'https://celestrak.org',
    license: { name: 'Éléments orbitaux publics (US Space Force)' },
    attribution: 'Éléments orbitaux : CelesTrak. Passages calculés par Ermont Live.',
  },
  hubeau: {
    id: 'hubeau',
    name: 'Hub’Eau (ministère chargé de la santé)',
    homepage: 'https://hubeau.eaufrance.fr/page/api-qualite-eau-potable',
    license: { name: 'Licence Ouverte', url: 'https://www.etalab.gouv.fr/licence-ouverte-open-licence/' },
    attribution: 'Contrôle sanitaire des ARS, ministère chargé de la santé, via Hub’Eau',
  },
  'atmo-france': {
    id: 'atmo-france',
    name: 'Atmo France / Airparif',
    homepage: 'https://www.atmo-france.org',
    license: { name: 'ODbL', url: 'https://opendatacommons.org/licenses/odbl/' },
    attribution: 'Atmo France / Airparif',
  },
  'ville-ermont': {
    id: 'ville-ermont',
    name: "Ville d'Ermont",
    homepage: 'https://www.ermont.fr',
    // Reprise des titres, dates et liens avec l'accord de la Ville (obtenu en septembre 2026).
    license: { name: 'Reprise avec l’accord de la Ville', url: 'https://www.ermont.fr/54/mentions-legales.htm' },
    attribution: "Ville d'Ermont (ermont.fr)",
  },
  'annuaire-service-public': {
    id: 'annuaire-service-public',
    name: "Annuaire de l'administration (service-public.gouv.fr)",
    homepage: 'https://www.data.gouv.fr/dataservices/api-annuaire-de-ladministration-et-des-services-publics',
    license: { name: 'Licence Ouverte 2.0', url: 'https://www.etalab.gouv.fr/licence-ouverte-open-licence/' },
    attribution: 'DILA, Annuaire de l’administration',
  },
  osm: {
    id: 'osm',
    name: 'OpenStreetMap',
    homepage: 'https://www.openstreetmap.org/copyright',
    license: { name: 'ODbL', url: 'https://www.openstreetmap.org/copyright' },
    attribution: '© les contributeurs d’OpenStreetMap',
  },
} as const satisfies Partial<Record<ProviderId, DataSource>>;

export type KnownProviderId = keyof typeof DATA_SOURCES;

export function getDataSource(id: KnownProviderId): DataSource {
  return DATA_SOURCES[id];
}
